import "./mural.scss";
import briefcase from "./assets/briefcase.png";
import mural from "./assets/mural.jpg";
import eggs from "./assets/eggs.jpg";
import names from "./assets/names.json";
import results from "./assets/results.png";
import title from "./assets/title.png";
import { motion } from "framer-motion";
import { fade, rise, childFade } from "../fade.js";
import ImageSlider from "react-image-comparison-slider";

const Mural = () => {
  return (
    <section class="section mural">
      <div className="hero">
        <motion.div
          className="text"
          variants={fade}
          initial="hide"
          whileInView="show"
          viewport={{ once: true }}
        >
          <img src={title} alt="Recruiting the locals!" className="title" />
          <p>
            We mobilised 11 of Indonesia's most promising and well-loved artists
            to join in on the hijack by creating "The Final Tribute", a
            hyper-localised 360° digital mural filled with 22 easter eggs to pay
            homage to the show's characters. We sent them a classified
            briefcase, which contained a blueprint and a letter from the
            Professor. Each artist was tasked to draw one character in their own
            distinct style, which would later be pieced together to form this
            mural.
          </p>
          <motion.a
            href="https://www.facebook.com/NetflixIndonesia/photos/4205369872917638"
            target="_blank"
            className="btn"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.9 }}
          >
            See the mural
          </motion.a>
          <img
            src={results}
            alt="results"
            className="results"
            variants={rise}
            initial="hide"
            whileInView="show"
            viewport={{ once: true }}
          />
        </motion.div>
        <motion.img
          src={briefcase}
          alt="Image of Briefcase"
          className="briefcase"
          variants={rise}
          initial="hide"
          whileInView="show"
          viewport={{ once: true }}
        />
      </div>
      <motion.div
        className="mural-img"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      >
        <ImageSlider
          image1={eggs}
          image2={mural}
          sliderWidth={3}
          sliderColor="white"
          handleColor="black"
        />
      </motion.div>
      {/*     <motion.img
        src={mural}
        alt="Mural"
        className="mural-img"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      /> */}
      <motion.div
        className="artists"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      >
        {names.map((n) => (
          <motion.a
            href={`https://instagram.com/${n.url}`}
            target="_blank"
            key={n.url}
            variants={childFade}
          >
            <div className="artist">
              <img
                src={`${process.env.PUBLIC_URL}/artists/${n.image}`}
                alt={n.url}
              />
              <p>@{n.url}</p>
            </div>
          </motion.a>
        ))}
      </motion.div>
      <div
        className="iframe"
        dangerouslySetInnerHTML={{
          __html: `

        <iframe
          src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2FNetflixIndonesia%2Fposts%2F4205446772909948&show_text=false&width=375"
          style="border:none;overflow:hidden"
          scrolling="no"
          frameborder="0"
          allowfullscreen="false"
          width="375"
          data-width="375"
          height="100%"
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        ></iframe>
        `,
        }}
      />
    </section>
  );
};

export default Mural;
